export default {
  called: '日本語',
  langs: {
    'zh': '中文',
    'en': '英文',
    'ja': '日本語'
  },
  contact: '今連絡する',
  gloaleTitle: 'あらゆる言語に堪能',
  gloaleText: '最高のオンラインチューターと自信を持って話す準備ができています',
  services: '世界中の質の高い外国人教師リソース',
  serviceContent: '世界をあなたの快適ゾーンにする',
  serviceItems: [{
    title: '新しい文化に浸る',
    desc: '世界中の言語の専門家とつながる'
  }, {
    title: '必要なときに専門家の助けを得る',
    desc: 'どの言語でも問題を解決することを学ぶ'
  }, {
    title: '成功したキャリア',
    desc: '作業用の語彙を開発し、明確にコミュニケーションする'
  }, {
    title: '常に自然に話す',
    desc: '良い印象を与え、あらゆる言語で信頼を築く'
  }],
  items: [{
    title: 'プロの家庭教師',
    desc: 'ネイティブスピーカーと認定プライベートチューターを見つける'
  }, {
    title: '確認済みプロフィール',
    desc: '各メンターの個人情報を注意深く確認します'
  }, {
    title: 'いつでも学ぶ',
    desc: '忙しいスケジュールに合わせて、最適なタイミングでオンラインコースを受講してください。'
  }, {
    title: '手頃な価格',
    desc: '予算に合った経験豊富な講師を選ぶ'
  }],
  teachLabel: 'オンラインとオフラインで、最高の外国人教師と自信を持って話す準備ができています',
  endLabel: 'チーム向けの一対一のビジネス言語トレーニング',
  endSmall: '従業員はいつでもどこでも発音を練習したり、ビジネス言語スキルを向上させたりできます<br>各チューターは、学習者が短期的または長期的な目標を達成し、ビジネス言語を改善するのを支援するための個別の計画を提供します',
  just: '言語を学ぶだけではありません',
  justval: 'BBtalkで生涯のスキルを学び、新しい視点を開発し、そして、 世界中の人々とつながります。 ',
  letStart: '今すぐ始める'

}